<template>
    <el-drawer
        title="详情"
        :visible.sync="drawerShow"
        :wrapperClosable="false"
        :destroy-on-close="true"
        size="auto"
        @close="close"
    >
        <div class="drawer-content">
			<div class="container">
				<el-row v-if="itemData">
				    <el-col :xl="24">
				        <ul>
				            <li>
				                <span class="title">所属演出:</span>
				                <span>{{ itemData.activityId }} {{ itemData.activityName }}</span>
				            </li>
				            <li>
				                <span class="title">取消订单数:</span>
				                <span>{{ itemData.cancelNum }}</span>
				            </li>
				            <li>
				                <span class="title">申请人:</span>
				                <span>{{ itemData.createUserName }} {{ itemData.createTime }}</span>
				            </li>                       
				            <li>
				                <span class="title">取消原由:</span>
				                <span>{{itemData.reason}}</span>
				            </li>
							<li>
							    <span class="title">扣除手续费:</span>
							    <span>{{ChargesNum}}</span>
							</li>
				            <li>
				                <span class="title">当前状态:</span>
				                <span v-if="itemData.status == 0" >待审核</span>
								<span v-else-if="itemData.status == 1" class="color-success">已通过</span>
								<span v-else-if="itemData.status == 2" class="color-danger">已拒绝</span>
								<span v-if="isDelivery == 1" class="color-danger">（已发货）</span>
				            </li>
				            <li>
				                <span class="title">审核人:</span>
				                <span>{{itemData.auditUserName}}</span>
				            </li>
							<li>
							    <span class="title">审核时间:</span>
							    <span>{{itemData.auditTime}}</span>
							</li>
							
				        </ul>
				    </el-col>
				</el-row>
				<div>
					<el-alert show-icon type="error" v-if="errorMsg" :closable="false">
					    <div slot="title">{{errorMsg}}</div>
					</el-alert>
				</div>
			</div>                   
        </div>
        <div class="drawer-footer">
			<template v-if="itemData && itemData.status == 0">
				<el-button type="success" size="medium" @click="passOrReject(1)" :loading="btnLoading">通过</el-button>
				<el-button type="danger"  size="medium" @click="passOrReject(2)" :loading="cancelBtnloading">拒绝</el-button>
			</template>
			<!-- <template v-if="itemData && itemData.status == 1">
				<el-button type="primary" size="medium" @click="restoreCheck()" >订单还原</el-button>				
			</template> -->
            <template v-if="itemData && ( itemData.status == 1 || itemData.status == 2 )">            	
            	<el-button @click="close">关闭</el-button>
            </template>
        </div>
		<el-dialog title="订单还原" :visible.sync="dialogVisible" width="600px"  v-if="restoreData && restoreData.length > 0" :append-to-body="true" :center="false">
			<div class="dialog-content">
				<div>			  
				   <p class="color-danger">还原后会造成超卖，是否继续还原？</p>
				   <div class="temp-table MT10">
				       <el-table
				           :data="restoreData"
				           style="width: 100%"
				           size="small"
				           border
				       >
				           <el-table-column prop="ticketName" label="票品名称"></el-table-column>
				           <el-table-column prop="num" label="超卖数量"></el-table-column>
				           
				       </el-table>
				   </div>				   
				</div>
			</div>
			<span slot="footer" class="dialog-footer">
				<el-button @click="dialogVisible = false">取 消</el-button>
				<el-button type="primary" @click="restore()">确 定</el-button>
			</span>
		</el-dialog>
    </el-drawer>
	
</template>

<script>


export default {
    data(){
        return{
            drawerShow: false,
            btnLoading: false,
			cancelBtnloading:false,
            itemData:null,
			dialogVisible:false,
			restoreData:[],
			errorMsg:'',
			ChargesNum:'',
			isDelivery:''
        }
    },
    created(){
        
    },
    methods:{
        close(){           
            this.errorMsg = ''
            this.drawerShow = false;
        },
        show(data){
            this.itemData = data;            
            this.drawerShow = true;
			this.getCharges()
        },
       
        passOrReject(operation){
			if( operation == 1){
				this.btnLoading = true
			}
			if( operation == 2){
				this.cancelBtnloading = true
			}
			
            this.$request({
                url: '/activityOrder/batchCancel/audio',
                method: 'POST',
                params: {                   
                    type: operation,
					auditId:this.itemData.id
                },
            }).then((res) => {
                const { state, msg } = res.data;
                if (state == 1 ) {
					this.$message.success("操作成功");
					this.close();
                    this.$emit('onUpdate');
					if( operation == 1){
						this.btnLoading = false
					}
					if( operation == 2){
						this.cancelBtnloading = false
					}
                } else {
                    this.$message.error(msg || "操作失败");
					this.close();
					this.$emit('onUpdate');
					if( operation == 1){
						this.btnLoading = false
					}
					if( operation == 2){
						this.cancelBtnloading = false
					}
                }
            })
            		
		},
		getCharges(){
			this.$request({
			    url: '/activityOrder/batchCancel/fee',
			    method: 'POST',
			    params: {			       
					auditId:this.itemData.id
			    },
			}).then((res) => {
			    const { state, msg,result } = res.data;
			    if (state == 1 ) {
					this.ChargesNum = result.refundFee
					this.isDelivery = result.isDelivery
					
			    } else {
			        this.$message.error(msg || "操作失败");
			    }
			})
			.finally(() => {
			    
			});	
		},
		restoreCheck(){
			this.$request({
			    url: '/activityOrder/batchCancel/restoreCheck',
			    method: 'POST',
			    params: {			       
					auditId:this.itemData.id
			    },
			}).then((res) => {
			    const { state, msg,result } = res.data;
			    if (state == 1 ) {
					if( result && result.ticketList && result.ticketList.length == 0 ) {
						this.restore()
					}
					if( result && result.ticketList && result.ticketList.length > 0 ){
						this.restoreData = result.ticketList
						this.dialogVisible = true
					}
					if( result && result.errorInfo ){
						this.errorMsg = result.errorInfo
						return this.$message.error(result.errorInfo);
						
					}
					
			    } else {
			        this.$message.error(msg || "操作失败");
			    }
			})
			.finally(() => {
			    
			});		
		},
		restore(){
			this.$request({
			    url: '/activityOrder/batchCancel/restore',
			    method: 'POST',
			    params: {			       
					auditId:this.itemData.id
			    },
			}).then((res) => {
			    const { state, msg,result } = res.data;
			    if (state == 1 ) {
					this.$message.success("操作成功");
					this.close();
			        this.$emit('onUpdate');
			    } else {
			        this.$message.error(msg || "操作失败");
			    }
			})
			.finally(() => {
			    
			});	
		}
    }
}
</script>
<style lang="scss" scoped>
.container{
	width: 100%;
    li{
        display: flex;
        // line-height: 50px;
        margin: 15px 0;
        .title{
            width: 90px;
            text-align: right;
            margin-right: 10px;
            color: $--color-info;
            flex-shrink: 0;
        }
        &>div{
            overflow: hidden;
            width: 100%;
        }
    }
}
</style>